import React from "react";
import AddChild from "site_media/images/add-child-button-mobile.png";
import "containers/Template/Header/Header.css";
import "containers/Template/Header/Desktop/Toolbar.css";
import UploadPhoto from "site_media/images/default-profile-pic-feeds.png";
import AxiosConfig from "axiosConfig";
const baseURL = process.env.REACT_APP_API_ENDPOINT.substring(
  0,
  process.env.REACT_APP_API_ENDPOINT.lastIndexOf("/")).slice(0,-3);


/**
 * @description Creates the toolbar section in the header with
 * list of kids and settings icon
 * @class Toolbar
 * @implements BroweserRouter as Router
 * @extends React.Component
 * @type {Toolbar}
 * @example <Toolbar />
 * pre-condition: all the imports
 * post-condition: returns the a dropdown of kids under that account
 * and settings icon
 * @param null
 * @returns {Toolbar}
 * @todo connect to database to get all the kids under that account
 */
class Toolbar extends React.Component {
  constructor(props) {
    super(props);
  }

  onUpdateUser(email, is_above_eighteen) {
    function updateUserState(prop, response) {
      sessionStorage.setItem("userEmail", email);
      prop.onUpdateUser(is_above_eighteen);
    }

    let form_data = new FormData();
    form_data.append("email", email);

    let prop = this.props;
    return AxiosConfig.post(`account/switch/`, form_data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then(function (response) {
        updateUserState(prop, response);
      })
      .catch(err => {
        window.location.assign("/logout");
      });
  }

  render() {
    const resultURL = baseURL.replace(/(^\w+:|^)\/\//, '');
    return (
      <div className="child-select__dropdown-menu-wrapper">
        {this.props.otherUsers !== ""
          ? this.props.otherUsers.map((elem) => (
              <div
                key={elem.email}
                className="child-select__item child-select__item--dropdown "
                onClick={this.onUpdateUser.bind(
                  this,
                  elem.email,
                  elem.is_above_eighteen
                )}
              >
                <div className="child-select__profile">
                  {elem.profile_pic !== "" && elem.profile_pic != null ? (
                    <div
                      className="child-select__avatar"
                      style={{
                        backgroundImage: elem.profile_pic.includes(resultURL)
                          ? `url(${elem.profile_pic})`
                          : `url(${baseURL}${elem.profile_pic})`,
                      }}
                      alt={elem.full_name}
                    />
                  ) : (
                    <div
                      className="child-select__avatar"
                      style={{ backgroundImage: `url(${UploadPhoto})` }}
                      alt={elem.full_name}
                    />
                  )}
                  <div className="child-select__info">
                    <div className="child-select__name">{elem.full_name}</div>
                  </div>
                </div>
              </div>
            ))
          : ""}

        {this.props.is_above_eighteen ? (
          <>
            <div className="child-select__item child-select__item--dropdown ">
              <div className="child-select__profile">
                <div
                  className="child-select__avatar"
                  style={{ backgroundImage: `url(${AddChild})` }}
                />
                <div className="child-select__info">
                  <div className="child-select__name">
                    <a href={"/add-child"} className="add-child-web">
                      Add new child
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </div>
    );
  }
}

export default Toolbar;
